import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/courses/CoursePageComponent.tsx");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/common/avatar.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/course/after-10th.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/course/after-12th.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/course/certification.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/course/diploma.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/course/masters.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/course/phd.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/modals/admission-icon.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/modals/college-predictor.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/modals/education-loan.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/modals/placement.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/modals/review.png");
;
import(/* webpackMode: "eager" */ "/app/assets/icons/modals/scholarship.png");
;
import(/* webpackMode: "eager" */ "/app/assets/logo/exams.webp");
;
import(/* webpackMode: "eager" */ "/app/assets/logo/find-college.webp");
;
import(/* webpackMode: "eager" */ "/app/assets/logo/study-abroad.webp");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
